import React, { useState } from 'react';
import { useDropzone } from 'react-dropzone';
import apiService from '../../../services/apiService';
import { useNavigate } from 'react-router';
import CustomToast from '../../Toast';
import Loader from '../../layouts/loader';


const UploadLogo = () => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [loader, setLoader] = useState(false);
  const [file, setFile] = useState(null);
  const navigate = useNavigate()

  const onDrop = async (acceptedFiles) => {
    const file = acceptedFiles[0];
    if (file && file.size <= 5 * 1024 * 1024) {
      setSelectedFile(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewUrl(reader.result);
      };
      reader.readAsDataURL(file);
    } else {
      setSelectedFile(null);
      setPreviewUrl(null);
      CustomToast.error('Please choose a valid image file (max size: 5MB).');
    }
  }

  const { fileRejections, getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept: {
      'image/*': ['.jpeg', '.png', '.svg', '.jpg'],
    }
  });

  const fileRejectionItems = fileRejections.map(({ file, errors }) => (
    <ul key={file.path}>
      <li>
        {file.path} - {file.size} bytes
        <ul>
          {errors.map((e) => (
            <li key={e.code}>{e.message}</li>
          ))}
        </ul>
      </li>
    </ul>
  ));

  const handleSubmit = (e) => {
    e.preventDefault();
    // console.log('File:', file);
  };

  const upDateData = async () => {
    try {
      if (!selectedFile) {
        CustomToast.error('Please choose a file');
        setLoader(false);
      } else {

        setLoader(true);
        let getUserData = sessionStorage.getItem('userDetail')
        if (getUserData) {
          getUserData = JSON.parse(getUserData)
        }
        const token = apiService.getAuthToken()
        const orgResult = await apiService.getv1(`get-org-details/${getUserData.org_id}`, token);
        if (orgResult && orgResult?.status == "success") {
          localStorage.setItem('orgInfo', JSON.stringify(orgResult?.data))
        }

        const formData = new FormData();
        formData.append('image', selectedFile);
        formData.append("contract_start_date", orgResult?.data?.contract_start_date);
        formData.append("contract_end_date", orgResult?.data?.contract_end_date);


        const result = await apiService.patchV1(`update-org/${getUserData.org_id}`, formData);
        if (result && result.status === 'success') {

          CustomToast.success('Org image updated successfully')
          // navigate('/')
          setTimeout(() => {
            window.location.reload(true);
          }, 1000);

          console.log("====>", formData);
        }
        setLoader(false);
      }
    } catch (error) {
      console.error(error);
      //alert('Something went wrong');
      setLoader(false);
      CustomToast.error('Something went wrong');
    }
  };
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);


  const isWide = windowWidth > 1500;

  return (
    <>
      <div className="d-flex flex-row align-items-center gap-4">
        <div className="card1 mb-3">
          <div className="card-body p-0">
            <form className="text-end ps-2" onSubmit={(e) => e.preventDefault()}>
              {loader ? (
                <Loader />
              ) : (
                <div className="d-flex flex-row align-items-center">
                  <div
                    {...getRootProps()}
                    className="d-flex flex-column align-items-center justify-content-center rounded-3"
                    style={{
                      width: '175px',
                      height: '175px',
                      border: '2px dashed #6c757d',
                      backgroundColor: '#F2F2F2',
                      cursor: 'pointer',
                    }}
                  >
                    <input {...getInputProps()} />
                    {previewUrl ? (
                      <div
                        style={{
                          position: 'relative',
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          width: '100%',
                          height: '100%',
                        }}
                      >
                        <img
                          src={previewUrl}
                          alt="Selected Preview"
                          className="mb-2"
                          style={{
                            maxWidth: '100%',
                            maxHeight: '100%',
                            objectFit: 'contain',
                          }}
                        />

                        <div
                          onClick={(e) => {
                            e.stopPropagation();
                            const fileInput = document.createElement('input');
                            fileInput.type = 'file';
                            fileInput.accept = 'image/*';
                            fileInput.onchange = (event) => {
                              const files = event.target.files;
                              if (files.length > 0) {
                                onDrop([files[0]]);
                              }
                            };
                            fileInput.click();
                          }}
                          style={{
                            position: 'absolute',
                            bottom: '8px',
                            right: '8px',
                            background: '#ffffff',
                            borderRadius: '50%',
                            padding: '6px',
                            boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
                            cursor: 'pointer',
                          }}
                        >
                          <img src="/images/edit-icon.svg" alt='edit' width={20} height={20} />
                        </div>
                      </div>
                    ) : (
                      <>
                        <img
                          src="./images/upload-icon.svg"
                          alt="Upload Icon"
                          width="48"
                          height="48"
                          className="mb-2"
                        />
                        <p className="text-center text-muted small m-0">
                          Drag and drop your file here or
                          <a href="#" className="text-primary text-decoration-underline ms-1">
                            Browse
                          </a>
                        </p>
                      </>
                    )}

                  </div>
                  <div className="ms-4">
                    <h2 className="text-start fw-bold mb-3 font-20">
                      Please upload your <br /> organisation logo
                    </h2>
                    <p className="text-start text-muted small mb-1">
                      Size of the logo should not exceed than 5MB
                    </p>

                    <button
                      type="submit"
                      onClick={upDateData}
                      className="rounded-pill px-4 py-2 border-0 text-end mt-2"
                      style={{
                        marginLeft: 'auto',
                        backgroundColor: selectedFile ? '#156b90' : '#DBDBDB',
                        color: '#ffffff',
                        cursor: selectedFile ? 'pointer' : 'not-allowed',
                        opacity: selectedFile ? 1 : 0.6,
                      }}
                      disabled={!selectedFile}
                    >
                      Save
                    </button>
                  </div>
                </div>
              )}


            </form>
            {/* {fileRejectionItems.length > 0 && (
                        <div className="error">
                        <p>Error: Invalid file type or size. Please choose a valid image file (max size: 5MB).</p>
                        {fileRejectionItems}
                        </div>
                    )} */}
          </div>
        </div>
      </div>
    </>
  )

}

export default UploadLogo;